const Home = () => import("~/components/Views/Prova/Home");
const Inicio = () => import("~/components/Views/Inicio");
const NotFound = () => import("~/components/Views/Prova/NotFound");
const Forbidden = () => import("~/components/Views/Prova/Forbidden");
const AplicacaoProvaPrint = () =>
  import("~/components/Views/Prova/AplicacaoProva/Print");
const ImpressaoProva = () =>
  import("~/components/Views/Prova/AplicacaoProva/PrintProva");
const ImpressaoGabarito = () =>
  import("~/components/Views/Prova/AplicacaoProva/PrintGabarito");
const Perfil = () => import("~/components/Views/Perfil");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

import { administracao } from "./administracao";
import { classificacao } from "./classificacao";
import { configuracao } from "./configuracao";
import { conteudo } from "./conteudo";
import { gerenciamento } from "./gerenciamento";
import { relatorio } from "./relatorio";
import { alunos } from "./alunos";
import { grupoConteudo } from "./grupoConteudo";
import { visualizarProva } from "./visualizarProva";

export const prova = [
  {
    path: "/prova/gerenciamento/aplicacaoProva/printProva/:id",
    component: ImpressaoProva,
    name: "Imprimir Prova",
    meta: {
      middleware: [auth, perfilVerify],
      breadcrumb: [
        { name: "Integrado", link: "http://on.grupointegrado.br/" },
        { name: "Perfil", link: "" }
      ]
    }
  },
  {
    path: "/prova/gerenciamento/aplicacaoProva/printGabarito/:id",
    component: ImpressaoGabarito,
    name: "Imprimir Gabarito",
    meta: {
      middleware: [auth, perfilVerify],
      breadcrumb: [
        { name: "Integrado", link: "http://on.grupointegrado.br/" },
        { name: "Perfil", link: "" }
      ]
    }
  },
  {
    path: "/prova/gerenciamento/aplicacaoProva/print/:id",
    component: AplicacaoProvaPrint,
    name: "Imprimir Instruções",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb: [
        { name: "Integrado", link: "http://on.grupointegrado.br/" },
        { name: "Perfil", link: "" }
      ]
    }
  },
  {
    path: "",
    component: Home,
    name: "Perfil",
    children: [
      {
        path: "perfil",
        component: Perfil,
        name: "Perfil",
        meta: {
          middleware: auth,
          breadcrumb: [
            { name: "Integrado", link: "http://on.grupointegrado.br/" }
          ]
        }
      }
    ]
  },
  {
    path: "/prova",
    component: Home,
    name: "Início",
    children: [
      ...administracao,
      ...classificacao,
      ...configuracao,
      ...conteudo,
      ...gerenciamento,
      ...relatorio,
      ...alunos,
      ...grupoConteudo,
      ...visualizarProva,
      {
        path: "/prova/inicio",
        component: Inicio,
        name: "Início",
        meta: {
          middleware: auth,
          breadcrumb: [
            { name: "Integrado", link: "http://on.grupointegrado.br/" }
          ]
        }
      },
      {
        path: "/prova/404",
        component: NotFound,
        name: "404 ",
        meta: {
          middleware: auth,
          breadcrumb: [
            { name: "Integrado", link: "http://on.grupointegrado.br/" }
          ]
        }
      },
      {
        path: "/prova/403",
        component: Forbidden,
        name: "403",
        meta: {
          middleware: auth,
          breadcrumb: [
            { name: "Integrado", link: "http://on.grupointegrado.br/" }
          ]
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/index.js